export default "__VITE_ASSET__bUWHNEuh__"